import React from 'react';

export const Add = (props) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.994 10.788V0.866H5.842V10.788H3.994ZM0.254 6.74V4.936H9.582V6.74H0.254Z"
      fill="white"
    />
  </svg>
);
